<template>
    <section class="section-outline" v-if="isMounted">
        <mvtCollapse :disable="disableCollapse" :isActive="isActive">
            <template v-slot:header="collapsible">
                <h2 class="f2 text-bold">Sell your home <sub class="sub">See what you could make selling {{ dpp.geo.address }}</sub></h2>
                <div class="f5 text-gray" v-show="collapsible.collapsed">Estimated Net Proceeds: {{$filters.formatPrice(netProceeds)}}</div>
            </template>
            <template v-slot:default>
               <mvtSaleProceedsNew @netProceeds="updateNetProceeds" :salePrice="getAvmValuation || getEstPrice"/>
            </template>
        </mvtCollapse>
    </section>
</template>
<script src="./property-saleproceeds.js"></script>

<style lang="scss">
@use './property-saleproceeds.scss' as *;
</style>
